<template>
  <div>
    <VCardText>
      <span>
        {{ $t('inviteTextHeader') }}
      </span>
      <VForm class="mt-8" autocomplete="off" @submit.prevent>
        <v-textarea
          class="mt-3"
          color="teal"
          autofocus
          outlined
          dense
          v-model="notificationText"
        >
          <template v-slot:label>
            <div>
              {{ $t('textAreaHeader') }}
            </div>
          </template>
        </v-textarea>
        <div class="btn-container">
          <button
            class="btn btn-copy copy-link elevation-0 primary--text font-weight-regular"
            @click="copyLink"
          >
            {{ $t('copyNotificationText') }}
            <span>
              <VIcon v-if="linkCopied" color="success" class="mr-2">
                mdi-check
              </VIcon>
            </span>
          </button>
          <RouterLink class="btn mb-2" to="/settings/templates">
            {{ $t('changeTemplate') }}
          </RouterLink>
        </div>
      </VForm>
    </VCardText>
  </div>
</template>

<script>
import NotificationTemplate from '@/orm/models/Company/NotificationTemplate/NotificationTemplate';
import { compileShareLinkNotificationTemplate } from '@/functions';
import { notificationChannelType, notificationType } from '@/enums';
import User from '@/orm/models/User/User';
import copy from 'clipboard-copy';

export default {
  name: 'ShareableLink',
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: User.getAuthUser(),
      notificationText: '',
      linkCopied: false,
    };
  },
  created() {
    this.notificationText = this.compileNotificationTemplate(notificationType.CANDIDATE_SHARE_LINK, notificationChannelType.EMAIL);
    if (this.notificationText.indexOf(this.vacancy.link) === -1) {
      this.notificationText = `${this.notificationText.trim()} \n \n${this.vacancy.link}`;
    }
  },
  methods: {
    compileNotificationTemplate(type, channel) {
      const template = NotificationTemplate.query()
        .where('companyId', this.user.company.id)
        .where('type', type)
        .where('channel', channel)
        .first();

      return compileShareLinkNotificationTemplate(
        template?.template ? template.template : '',
        this.user,
        this.user.company,
        this.vacancy,
      );
    },
    copyLink() {
      copy(this.notificationText);
      this.linkCopied = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn {
    &-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      transition: opacity 0.3s;
    }
    &:hover {
      opacity: 0.75;
    }
    &-copy {
      padding: 9px 16px 9px 51px ;
      border: 1px solid #C2C2C2;
      border-radius: 4px;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        border-right: 1px solid #C2C2C2;
        left: 0;
        height: 100%;
        top: 0;
        width: 40px;
        background-image: url(../../../src/assets/img/interview/icon-copy.svg);
        background-position: center;
      }
    }
  }

  .mb-2 {
    text-decoration: none;
    &:hover {
      opacity: 0.75;
    }
  }

  @media (max-width: 575px) {
    .btn {
      &-container {
        flex-direction: column;
      }
      &-copy {
        margin-bottom: 20px;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
inviteTextHeader: Send the candidates a link to the video interview in any convenient way (job site, messenger, etc.).
textAreaHeader: Invitation
copyNotificationText: Copy invitation text
changeTemplate: Edit template
</i18n>

<i18n locale="ru" lang="yaml">
inviteTextHeader: Отправьте кандидатам ссылку на видео-интервью любым удобным способом (job-сайт, мессенджер и т.п.).
textAreaHeader: Приглашение
copyNotificationText: Скопировать текст приглашения
changeTemplate: Редактировать шаблон
</i18n>
